// extracted by mini-css-extract-plugin
export default {"card":"ContextItem_card__xTAfg","cardHeader":"ContextItem_cardHeader__fkeh1","title":"ContextItem_title__vYjMj","cardBody":"ContextItem_cardBody__YTg1m"};